import {DATATABLE_SET_PAGINATION_DATA} from '~/frontend/src/constants';
import setParamOrig, {SetParamAction} from '~/frontend/src/actions/panel/common/setParam';
import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import {AllProps} from '~/frontend/src/components/base/DataTable';


type SetParam = <K extends keyof AllProps>( panelKey : string, paramKey : K, paramValue : AllProps[K] ) => SetParamAction;


const setParam = setParamOrig as SetParam;


/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {Number} page
 * @param {Number} rows
 *
 * @return {function}
 */
const setPaginationData = ( panelKey : string, page : number, rows : number ) : Thunk<Promise<void>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<void> => {
    dispatch( {
        type: DATATABLE_SET_PAGINATION_DATA,
        panelKey,
        page,
        rows
    } );

    dispatch( setParam( panelKey, 'page', page ) );
    dispatch( setParam( panelKey, 'rows', rows ) );
    dispatch( setParam( panelKey, 'doSearch', true ) );
}
export type SetPaginationData = typeof setPaginationData;

export default setPaginationData;
